// src/TEST/gateways/Stripe/StripePaymentMethodWrapper.js
import React, { useMemo } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";

const StripePaymentMethodWrapper = ({ public_key, options, children }) => {
  const stripePromise = useMemo(() => {
    if (!public_key) return null;
    return loadStripe(public_key);
  }, [public_key]);

  if (!public_key) return <div>Missing Stripe public key</div>;
  if (!stripePromise) return <div>Stripe not ready</div>;

  return (
    <Elements stripe={stripePromise} options={options}>
      {children}
    </Elements>
  );
};

export default StripePaymentMethodWrapper;
